/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Exercise_Note_Limit_ReachedInputs */

const en_us2_exercise_note_limit_reached = /** @type {(inputs: Exercise_Note_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can pin notes on up to ${i?.max} exercises. Delete one first.`)
};

const pt_br2_exercise_note_limit_reached = /** @type {(inputs: Exercise_Note_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você pode fixar notas em até ${i?.max} exercícios. Apague uma antes.`)
};

const es_419_exercise_note_limit_reached = /** @type {(inputs: Exercise_Note_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puedes fijar notas en hasta ${i?.max} ejercicios. Borra una primero.`)
};

const pt_pt2_exercise_note_limit_reached = /** @type {(inputs: Exercise_Note_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podes fixar notas em até ${i?.max} exercícios. Apaga uma primeiro.`)
};

const fr_fr2_exercise_note_limit_reached = /** @type {(inputs: Exercise_Note_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu peux épingler des notes sur ${i?.max} exercices au maximum. Supprimes-en une d'abord.`)
};

const de_de2_exercise_note_limit_reached = /** @type {(inputs: Exercise_Note_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du kannst Notizen an bis zu ${i?.max} Übungen anheften. Lösche zuerst eine.`)
};

const it_it2_exercise_note_limit_reached = /** @type {(inputs: Exercise_Note_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puoi fissare note su un massimo di ${i?.max} esercizi. Eliminane una prima.`)
};

/**
* | output |
* | --- |
* | "You can pin notes on up to {max} exercises. Delete one first." |
*
* @param {Exercise_Note_Limit_ReachedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_note_limit_reached = /** @type {((inputs: Exercise_Note_Limit_ReachedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Note_Limit_ReachedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_note_limit_reached(inputs)
	if (locale === "es-419") return es_419_exercise_note_limit_reached(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_note_limit_reached(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_note_limit_reached(inputs)
	if (locale === "de-DE") return de_de2_exercise_note_limit_reached(inputs)
	if (locale === "it-IT") return it_it2_exercise_note_limit_reached(inputs)
	return en_us2_exercise_note_limit_reached(inputs)
});
export { exercise_note_limit_reached as "exercise_note.limit_reached" }